import { State } from '../types';

/** Used to get initial state of store. */
export function getDefaultState(): State {
  return {
    videoCues: null
  };
}